import React, { useEffect, useState, memo } from "react";
import { Postrequestcall } from "../../../request/Postrequest";
import { FETCH_CLIENT_TIMESHEET_JOBS_V2_NEW } from "../../../constant/Apipath";
import { useSelector } from "react-redux";
import { Avatar, Box, Card, Grid, IconButton, Modal, Stack, Typography, Collapse } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import HelpIcon from "@mui/icons-material/Help";
import moment from "moment";
import TimesheetSkeletonLoader from "../shared/components/TimesheetSkeletonLoader";

import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { ClientUDFieldComponent } from "../../safety-observation/ClientUDFieldComponent";
import PictureViewer from "../../../common/PictureViewer";

const ImageList = ({ uploadedImageList, setPictureViewerOpen, setPictureIndex, setPictures }) => {
  const ImgUrl = (file) => {
    try {
      let url = URL.createObjectURL(file);
      return url;
    } catch (error) {
      return file;
    }
  };

  return uploadedImageList?.map((picture, index) => (
    <div style={{ position: "relative", height: "100px", marginRight: "10px", marginBottom: "10px" }} key={index}>
      <img
        loading="lazy"
        onClick={(e) => {
          e.stopPropagation();
          setPictures(uploadedImageList);
          setPictureViewerOpen(true);
          setPictureIndex(index);
        }}
        src={picture?.fileUrl || ImgUrl(picture?.file)}
        alt={"NO data"}
        style={{
          cursor: "pointer",
          width: "100px",
          height: "100px",
          borderRadius: "10px"
        }}
      />
    </div>
  ));
};
const ImageMemoComponent = memo(ImageList);

let CLIENT_COLOR = "#000000";

export default function ClientViewGeneratedTimesheet({ isOpen, onClose, item, setHelpModal }) {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  CLIENT_COLOR = selectedClientData?.AccentColor;
  const TOKEN = loginData?.accessToken;
  const USER_ID = loginData?.userInformation?.UserId;

  const { TEXT_DATE, TEXT_ACTIVITIES, TEXT_HOURS, TEXT_JOB, TEXT_FOREMAN, TEXT_SUBMITTED_ON, TEXT_IN, TEXT_OUT, TEXT_EMPLOYEE } =
    ClientEnglishFallback?.AddTimesheetModal(multiLanguageData?.AddTimesheetModal || {});

  const [isLoading, setIsLoading] = useState(true);
  const [headerData, setHeaderData] = useState(null);
  const [activityIndex, setActivityIndex] = useState(null);
  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
  const [pictureIndex, setPictureIndex] = useState(0);
  const [pictures, setPictures] = useState([]);

  useEffect(() => {
    if (isOpen === true) {
      getClientIndividualTimesheet();
    }
  }, [isOpen]);

  const getClientIndividualTimesheet = async () => {
    try {
      const clientTimesheetObject = {
        PageNr: 1,
        FullSearch: "",
        UserId: USER_ID,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [{ ClientTimesheetId: item?.id }]
      };
      const getResponse = await Postrequestcall(
        FETCH_CLIENT_TIMESHEET_JOBS_V2_NEW,
        clientTimesheetObject,
        TOKEN,
        false
      );
      if (getResponse.status === 200) {
        if (getResponse?.data?.data?.length > 0) {
          let data = getResponse.data.data[0];
          // Filter pictures to only those added by this employee
          data.timesheetActivitiesList = data.timesheetActivitiesList?.map((act) => ({
            ...act,
            pictureList: act.pictureList?.filter(
              (pic) => pic.clientEmployeeId === selectedClientData?.ClientEmployeeId
            ) || []
          }));
          setHeaderData(data);
        }
      }
    } catch (e) {
      console.log("getClientIndividualTimesheet-> Error: ", e);
    } finally {
      setIsLoading(false);
    }
  };

  if (!headerData && !isLoading) {
    return null;
  }

  return (
    <>
      <Modal open={isOpen} onClose={onClose}>
        <Box
          sx={{
            padding: { xs: "10px", sm: "10px", md: "15px", lg: "15px", xl: "15px" },
            maxHeight: "600px",
            overflowY: "scroll"
          }}
          className="client-modal-responsive">
          <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>
            <IconButton size="small" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Stack>

          {isLoading ? (
            <TimesheetSkeletonLoader variant="detail" />
          ) : (
            <>
              <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center", mb: "10px" }}>
                <Stack>
                  <Typography sx={{ color: "grey" }}>{TEXT_FOREMAN}</Typography>
                  <Stack direction="row" sx={{ alignItems: "center", gap: "10px" }}>
                    <Avatar src={headerData.timesheetHoursList?.[0]?.foremanClientEmployeePicture || ""} />
                    <Typography>{headerData.timesheetHoursList?.[0]?.foremanClientEmployeeName || ""}</Typography>
                  </Stack>
                </Stack>
                <IconButton onClick={(e) => { e.stopPropagation(); setHelpModal(true); }} size="small">
                  <HelpIcon sx={{ color: "#000000" }} />
                </IconButton>
              </Stack>

              <Grid container sx={{ mb: "10px" }}>
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                  <Stack>
                    <Typography sx={{ color: "grey" }}>{TEXT_DATE}</Typography>
                    <Typography>{moment(headerData.date).format("MMMM D, YYYY")}</Typography>
                  </Stack>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                  <Stack>
                    <Typography sx={{ color: "grey" }}>{TEXT_SUBMITTED_ON}</Typography>
                    <Typography>{moment(headerData.dateSubmitted).format("MMMM D, YYYY")}</Typography>
                  </Stack>
                </Grid>
              </Grid>

              <Stack sx={{ marginBottom: "10px" }}>
                <Typography sx={{ color: "grey" }}>{TEXT_JOB}</Typography>
                <Typography>{`${headerData.clientJobCode} - ${headerData.clientJobName}`}</Typography>
                {headerData.udFieldsList?.length > 0 && (
                  <Stack sx={{ mt: "5px" }}>
                    <ClientUDFieldComponent mode="view" udFields={headerData.udFieldsList} />
                  </Stack>
                )}
              </Stack>

              {headerData.timesheetEmployeesList?.map((emp, index) => {
                if (emp.clientEmployeeId === selectedClientData?.ClientEmployeeId && emp.udFieldsList?.length > 0) {
                  return (
                    <Stack key={index} sx={{ marginBottom: "10px" }}>
                      <Typography sx={{ color: "grey", marginBottom: "5px" }}>{TEXT_EMPLOYEE} UD Fields</Typography>
                      <ClientUDFieldComponent mode="view" udFields={emp.udFieldsList} />
                    </Stack>
                  );
                }
                return null;
              })}

              <Typography sx={{ fontWeight: "bold", margin: "10px 0px" }}>{TEXT_ACTIVITIES}</Typography>

              {headerData.timesheetActivitiesList?.map((act, index) => {
                const isClockIn = headerData.typeId === 4;
                const hoursItem = headerData.timesheetHoursList?.find(h => h.clientJobActivityId === act.clientActivityId && h.clientEmployeeId === selectedClientData?.ClientEmployeeId);
                const empHours = hoursItem?.hours || "00:00";

                const notesText = hoursItem?.notes?.trim() || act?.notes?.trim();
                const hasNotes = !!notesText && notesText !== "ActivityNotes";
                const hasPictures = act.pictureList?.length > 0;
                const hasUdFields = act.udFieldsList?.length > 0;
                const hasDetails = hasNotes || hasPictures || hasUdFields;

                return (
                  <Card key={index} className="pagelist-content" style={{ padding: "0px", marginBottom: "12px", borderRadius: "10px" }}>
                    <div
                      onClick={() => {
                        if (hasDetails) {
                          setActivityIndex(activityIndex === index ? null : index);
                        }
                      }}
                      style={{
                        padding: "15px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        cursor: hasDetails ? "pointer" : "default"
                      }}>
                      <div style={{ flex: 1 }}>
                        <Typography variant="h6">
                          {act.clientJobActivityCode} - {act.clientJobActivityName}
                        </Typography>

                        <Stack direction="row" sx={{ mt: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          {isClockIn && (
                            <>
                              <Stack flex={1}>
                                <Typography sx={{ color: "grey", fontSize: "14px" }}>{TEXT_IN}</Typography>
                                <Typography>{hoursItem?.clockInTime || "-"}</Typography>
                              </Stack>
                              <Stack flex={1}>
                                <Typography sx={{ color: "grey", fontSize: "14px" }}>{TEXT_OUT}</Typography>
                                <Typography>{hoursItem?.clockOutTime || "-"}</Typography>
                              </Stack>
                            </>
                          )}
                          <Stack flex={1}>
                            <Typography sx={{ color: "grey", fontSize: "14px" }}>{TEXT_HOURS}</Typography>
                            <Typography>{empHours}</Typography>
                          </Stack>
                        </Stack>
                      </div>

                      {hasDetails && (
                        <ArrowDropUpIcon
                          style={{
                            // marginTop: "15px",
                            flexShrink: 0,
                            transform: activityIndex === index ? "rotate(0deg)" : "rotate(180deg)",
                            transition: "transform 0.3s ease"
                          }}
                        />
                      )}
                    </div>

                    {hasDetails && (
                      <Collapse in={activityIndex === index} unmountOnExit>
                        <div style={{ padding: "0 15px 15px" }}>
                          {hasNotes && (
                            <Stack style={{ marginBottom: "15px" }}>
                              <Typography sx={{ color: "grey", fontSize: "14px" }}>Notes</Typography>
                              <Typography>{notesText}</Typography>
                            </Stack>
                          )}

                          {hasPictures && (
                            <div style={{ display: "flex", flexWrap: "wrap", marginBottom: "15px" }}>
                              <ImageMemoComponent
                                uploadedImageList={act.pictureList}
                                setPictureViewerOpen={setPictureViewerOpen}
                                setPictureIndex={setPictureIndex}
                                setPictures={setPictures}
                              />
                            </div>
                          )}

                          {hasUdFields && (
                            <ClientUDFieldComponent mode="view" udFields={act.udFieldsList} />
                          )}
                        </div>
                      </Collapse>
                    )}
                  </Card>
                );
              })}
            </>
          )}
        </Box>
      </Modal>
      <PictureViewer
        isOpen={pictureViewerOpen}
        onClose={() => setPictureViewerOpen(false)}
        pictures={pictures?.map(p => ({ src: p.fileUrl || "" })) || []}
        viewerIndex={pictureIndex}
      />
    </>
  );
}
